import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input, Output, EventEmitter } from '@angular/core';
var RoamingStepperItemComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function RoamingStepperItemComponent() {
        this.toggle = new EventEmitter();
        /**
         * Set our default values
         */
        this.localState = { value: '' };
    }
    RoamingStepperItemComponent.prototype.ngOnInit = function () {
    };
    return RoamingStepperItemComponent;
}());
export { RoamingStepperItemComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/roaming-stepper/roaming-stepper-item/roaming-stepper-item.component.ts
// module id = null
// module chunks = 